// 创建一个包含 mockApi.js 文件的上下文
const mockApiContext = require.context('../src', true, /mockApi\.js$/)
let mockApis = []
// 获取所有文件的路径
mockApiContext.keys().forEach(file => {
  // 导入每个文件
  const mockApiModule = mockApiContext(file)
  // 将每个文件导出的数组添加到总数组中
  mockApis = [...mockApis, ...mockApiModule.default]
})
export default mockApis
